import { DeckGL } from '@deck.gl/react';
import { HeatmapLayer, ScatterplotLayer } from "deck.gl";
import { Map } from 'react-map-gl/mapbox';
import { useLoaderData } from "react-router-dom";
import { ChicagoAbandonedVehicle } from "./api/Application";

export function AbandonedVehicleChicago311() {
    const vehicles = useLoaderData() as ChicagoAbandonedVehicle[];

    const scatterLayer = new ScatterplotLayer( {
        id: 'green-dots-layer',
        data: vehicles.map( v => {
            return { position: [v.lng, v.lat] }
        } ),
        getFillColor: [0, 255, 0, 255],
        getRadius: 1, // radius in meters
        radiusMinPixels: 3, // minimum size in pixels
        radiusMaxPixels: 100, // maximum size in pixels
        pickable: true
    } );

    const heatmap = new HeatmapLayer( {
        id: "verified-heatmap",
        data: vehicles.map( v => {
            return { p: [v.lng, v.lat] }
        } ),
        getPosition: v => v.p,
        aggregation: "SUM",
        getWeight:   1,
        radius:      50,
    } );

    return <div id="list-map-page">
        <div className="p-1">
            Pulls from Chicago 311 data to visualize years of abandoned vehicle data
        </div>
        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            <DeckGL
                initialViewState={{
                    longitude: -87.1652,
                    latitude: 41.9526,
                    zoom: 11,
                    pitch: 0,
                    bearing: 0
                }}
                controller={true}
                layers={[heatmap]}>
                <Map
                    mapStyle="mapbox://styles/mapbox/light-v9"
                    mapboxAccessToken="pk.eyJ1IjoiZGh5ajc3NyIsImEiOiJjbWFwdGswdjkwMGZyMm1vZDVjejUyOGRjIn0.h0Eb4kX2BTLxou4Eu50pCA" />
            </DeckGL>
        </div>
    </div>;
}